import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";

import { useStyles } from "@/hooks/useStyles.ts";
import { NurseInclusionPatient } from "@/models/NurseInclusionPatientModel.ts";
import { userFormattedName } from "@/models/UserModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type PatientNameColumnProps = CellContext<NurseInclusionPatient, unknown>;

export const PatientNameColumn: React.FC<PatientNameColumnProps> = ({ row: { original } }) => {
  const styles = useStyles(makeStyles);

  return (
    <Typography className={styles.container} variant="body">
      {userFormattedName(original.lastName, original.firstName)}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({}),
});
